import { useTranslation } from 'react-i18next';

import useSendScheduledMessageMutation from 'components/domain/automation/scheduledMessages/useSendScheduledMessageMutation';
import useModalId from 'components/modal/useModalId';
import useAppModal from 'hooks/useAppModal';
import useNotify from 'hooks/useNotify';
import { BaseErrorResponse } from 'models/_base';
import { ScheduledMessage } from 'models/automation/ScheduledMessages';
import { getErrorMessage } from 'utils/axiosExceptionUtils';

const useScheduledMessageSendNowModalFormSubmit = ({
  scheduledMessage,
}: {
  scheduledMessage: ScheduledMessage;
}) => {
  const { t } = useTranslation();
  const modalId = useModalId();
  const { closeModal } = useAppModal();
  const { notifyError, notifySuccess } = useNotify();

  const onError = (error: BaseErrorResponse) => {
    notifyError(
      getErrorMessage({
        apiErrorCode: error.response?.data?.apiErrorCode,
        apiErrorMessage: error.response?.data?.apiErrorMessage ?? '',
        baseKey: 'pageAutomations.triggers.apiErrorCodes.',
        t,
      }),
    );
  };

  const { mutateAsync: sendScheduledMessage } =
    useSendScheduledMessageMutation();

  const onSubmit = async () => {
    try {
      await sendScheduledMessage(
        {
          scheduledMessageUid: scheduledMessage.uid,
        },
        {
          onSuccess: () => {
            closeModal(modalId);
            notifySuccess(
              t('pageAutomations.scheduledMessages.modalSendNow.success'),
            );
          },
        },
      );
    } catch (error) {
      onError(error as BaseErrorResponse);
    }
  };

  return { onSubmit };
};

export default useScheduledMessageSendNowModalFormSubmit;
